var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9998 2.66663C8.64784 2.66663 2.6665 8.64796 2.6665 16C2.6665 23.352 8.64784 29.3333 15.9998 29.3333C23.3518 29.3333 29.3332 23.352 29.3332 16C29.3332 8.64796 23.3518 2.66663 15.9998 2.66663ZM15.9998 26.6666C10.1185 26.6666 5.33317 21.8813 5.33317 16C5.33317 14.4426 5.67717 12.9666 6.2785 11.632C6.48384 11.752 6.68917 11.8746 6.8865 12C7.4145 12.3333 7.94117 12.6666 8.60117 12.9173C9.25984 13.1666 10.0518 13.3333 11.1065 13.3333C12.1625 13.3333 12.9545 13.1666 13.6145 12.916C14.2745 12.6653 14.8025 12.3333 15.3305 12C15.8585 11.6666 16.3865 11.3333 17.0465 11.0826C17.7052 10.8333 18.4972 10.6666 19.5532 10.6666C20.6092 10.6666 21.4012 10.8333 22.0598 11.084C22.7198 11.3333 23.2478 11.6666 23.7758 12C24.3038 12.3333 24.8318 12.6666 25.4918 12.9173C25.7292 13.0066 25.9905 13.08 26.2665 13.1453C26.5212 14.0546 26.6665 15.0093 26.6665 16C26.6665 21.8813 21.8812 26.6666 15.9998 26.6666V26.6666Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3335 18.6666C12.4381 18.6666 13.3335 17.7712 13.3335 16.6666C13.3335 15.5621 12.4381 14.6666 11.3335 14.6666C10.2289 14.6666 9.3335 15.5621 9.3335 16.6666C9.3335 17.7712 10.2289 18.6666 11.3335 18.6666Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6665 18.6666C21.7711 18.6666 22.6665 17.7712 22.6665 16.6666C22.6665 15.5621 21.7711 14.6666 20.6665 14.6666C19.5619 14.6666 18.6665 15.5621 18.6665 16.6666C18.6665 17.7712 19.5619 18.6666 20.6665 18.6666Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFan);
export default __webpack_public_path__ + "static/media/fan.ad79a270accf4b6a0e94eb5d0b79c92d.svg";
export { ForwardRef as ReactComponent };